import { Screen } from "../components/Screen";
import { Footer } from "../components/Footer";
import { CSSProperties, useEffect, useState } from "react";
import { Font } from "../constants/fonts";
import { Colors } from "../constants/colors";

// Adicione aqui os caminhos das imagens
const IMAGE_PATHS = {
  mainImage: "integrante0.png",        // Imagem principal da equipe
  teamMember1: "integrante1.png",               // Foto do membro 1
  teamMember2: "integrante2.png",               // Foto do membro 2
  teamMember3: "integrante3.png",               // Foto do membro 3
  teamMember4: "integrante4.png",               // Foto do membro 4
  teamPhoto1: "integrante1.png",                // Primeira foto da equipe (desktop)
  teamPhoto2: "integrante2.png",                // Segunda foto da equipe (desktop)
  teamPhoto3: "integrante3.png",                // Terceira foto da equipe (desktop)
  teamPhoto4: "integrante4.png",                // Quarta foto da equipe (desktop)
};

export default function QuemSomos() {
    const [isMobile, setIsMobile] = useState(false);
    
    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth <= 768);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // Estilos desktop originais (mantidos intactos)
    const styles:  { [key: string]: CSSProperties } = {
        container: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            padding: 50,
            justifyContent: 'center',
            gap: 35
        },
        subContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: 15,
            justifyContent: 'center',
            alignItems: 'center',
            width: '40%'
        },
        subContainer2: {
            display: 'flex',
            flexDirection: 'column',
            gap: 30,
            justifyContent: 'center',
            alignItems: 'center',
            width: '50%',
            marginTop: -50
        },
        title: {
            fontSize: Font.title2.fontSize,
            fontWeight: Font.title2.fontWeight,
            color: Colors.white,
            textAlign: 'left',
            backgroundColor: Colors.primary,
            borderRadius: 20,
            padding: 45
        },
        legend: {
            fontSize: Font.menu.fontSize,
            color: Colors.white,
            textAlign: 'justify',
            backgroundColor: Colors.primary,
            borderRadius: 20,
            padding: 45
        },
        logo1: {
            width: '60%',
            aspectRatio: '3 / 2',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: 15,
            overflow: 'hidden',
            backgroundColor: Colors.white, // Fundo fixo
        },
        logo: {
            width: '100%',
            aspectRatio: '1 / 1',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: 15,
            overflow: 'hidden',
            backgroundColor: Colors.white, // Fundo fixo
        },
        logoImage: {
            width: '100%',
            height: '100%',
            display: 'block',
            objectFit: 'contain',
            objectPosition: 'center',
        },
        subTitle: {
            fontSize: Font.title2.fontSize-10,
            fontWeight: Font.title2.fontWeight,
            color: Colors.primary,
            textAlign: 'center',
            margin: 60,
            marginTop: 10
        },
        imageContainer: {
            position: 'relative',
            width: '100%',
            height: '100%',
            backgroundColor: Colors.white,
            display: 'flex',   
            justifyContent: 'center',
            alignItems: 'center'
        }
    }

    // Estilos mobile otimizados
    const mobileStyles: { [key: string]: CSSProperties } = {
        container: {
            display: 'flex',
            flexDirection: 'column',
            padding: '30px 20px',
            gap: 25,
        },
        title: {
            fontSize: Font.title2.fontSize * 0.85,
            fontWeight: Font.title2.fontWeight,
            color: Colors.white,
            textAlign: 'center',
            backgroundColor: Colors.primary,
            borderRadius: 15,
            padding: '25px 20px',
            lineHeight: 1.3,
        },
        legend: {
            fontSize: Font.menu.fontSize * 0.95,
            color: Colors.white,
            textAlign: 'center',
            backgroundColor: Colors.primary,
            borderRadius: 15,
            padding: '25px 20px',
            lineHeight: 1.5,
        },
        imagePlaceholder: {
            width: '100%',
            aspectRatio: '3 / 2',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: 15,
            marginTop: 10,
            overflow: 'hidden',
            backgroundColor: Colors.white, // Fundo fixo
        },
        placeholderText: {
            color: Colors.primary,
            fontSize: Font.menu.fontSize,
            opacity: 0.7,
        },
        subTitle: {
            fontSize: (Font.title2.fontSize - 10) * 0.85,
            fontWeight: Font.title2.fontWeight,
            color: Colors.primary,
            textAlign: 'center',
            padding: '30px 20px',
            lineHeight: 1.4,
            backgroundColor: Colors.white,
        },
        teamGrid: {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: 20,
            padding: '30px 20px',
            backgroundColor: Colors.white,
        },
        teamMember: {
            width: '100%',
            aspectRatio: '1 / 1',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: 12,
            overflow: 'hidden',
            backgroundColor: Colors.white, // Fundo fixo
        },
        memberImage: {
            width: '100%',
            height: '100%',
            display: 'block',
            objectFit: 'contain',
            objectPosition: 'center',
        },
        memberPlaceholder: {
            color: Colors.primary,
            fontSize: Font.menu.fontSize * 0.9,
            opacity: 0.7,
        },
        imageWrapper: {
            width: '100%',
            height: '100%',
            position: 'relative',
            backgroundColor: Colors.white, // Fundo fixo adicional
        }
    };

    if (isMobile) {
        return (
            <Screen>
                <div style={mobileStyles.container}>
                    <div style={mobileStyles.title}>
                        Pessoas que acreditam em pessoas.
                    </div>
                    <div style={mobileStyles.legend}>
                        O ClikMob é desenvolvido por um grupo de profissionais que acreditam que tecnologia e empatia podem caminhar lado a lado. Nosso compromisso é com o respeito, a valorização do trabalho e a construção de um serviço de mobilidade mais humano e acessível.
                    </div>
                    
                    <div style={mobileStyles.imagePlaceholder}>
                        <div style={mobileStyles.imageWrapper}>
                            {/* Imagem principal */}
                            <img 
                                src={IMAGE_PATHS.mainImage} 
                                alt="Equipe ClikMob" 
                                style={mobileStyles.memberImage} 
                                onError={(e) => {
                                    // Fallback para placeholder se a imagem não carregar
                                    const target = e.target as HTMLImageElement;
                                    target.style.display = 'none';
                                }}
                            />
                            <div style={mobileStyles.placeholderText}>
                                {IMAGE_PATHS.mainImage ? '' : 'Imagem da equipe'}
                            </div>
                        </div>
                    </div>
                </div>
                
                <div style={mobileStyles.subTitle}>
                    Estamos unindo inovação, responsabilidade e propósito para transformar o jeito de se mover — e queremos que você venha com a gente.
                </div>
                
                <div style={mobileStyles.teamGrid}>
                    <div style={mobileStyles.teamMember}>
                        <div style={mobileStyles.imageWrapper}>
                            <img 
                                src={IMAGE_PATHS.teamMember1} 
                                alt="Membro da equipe 1" 
                                style={mobileStyles.memberImage}
                                onError={(e) => {
                                    const target = e.target as HTMLImageElement;
                                    target.style.display = 'none';
                                }}
                            />
                            <div style={mobileStyles.memberPlaceholder}>
                                {IMAGE_PATHS.teamMember1 ? '' : 'Membro 1'}
                            </div>
                        </div>
                    </div>
                    <div style={mobileStyles.teamMember}>
                        <div style={mobileStyles.imageWrapper}>
                            <img 
                                src={IMAGE_PATHS.teamMember2} 
                                alt="Membro da equipe 2" 
                                style={mobileStyles.memberImage}
                                onError={(e) => {
                                    const target = e.target as HTMLImageElement;
                                    target.style.display = 'none';
                                }}
                            />
                            <div style={mobileStyles.memberPlaceholder}>
                                {IMAGE_PATHS.teamMember2 ? '' : 'Membro 2'}
                            </div>
                        </div>
                    </div>
                    <div style={mobileStyles.teamMember}>
                        <div style={mobileStyles.imageWrapper}>
                            <img 
                                src={IMAGE_PATHS.teamMember3} 
                                alt="Membro da equipe 3" 
                                style={mobileStyles.memberImage}
                                onError={(e) => {
                                    const target = e.target as HTMLImageElement;
                                    target.style.display = 'none';
                                }}
                            />
                            <div style={mobileStyles.memberPlaceholder}>
                                {IMAGE_PATHS.teamMember3 ? '' : 'Membro 3'}
                            </div>
                        </div>
                    </div>
                    <div style={mobileStyles.teamMember}>
                        <div style={mobileStyles.imageWrapper}>
                            <img 
                                src={IMAGE_PATHS.teamMember4} 
                                alt="Membro da equipe 4" 
                                style={mobileStyles.memberImage}
                                onError={(e) => {
                                    const target = e.target as HTMLImageElement;
                                    target.style.display = 'none';
                                }}
                            />
                            <div style={mobileStyles.memberPlaceholder}>
                                {IMAGE_PATHS.teamMember4 ? '' : 'Membro 4'}
                            </div>
                        </div>
                    </div>
                </div>
                
                <Footer
                    color={Colors.white}
                    backgroundColor={Colors.primary}
                    image="/LOGO%20TM%203.svg"
                />
            </Screen>
        );
    }

    // Return original (desktop)
    return (
        <Screen>
            <div style={styles.container}>
                <div style={styles.subContainer}>
                    <div style={styles.title}>
                        Pessoas que acreditam em pessoas.
                    </div>
                    <div style={styles.legend}>
                        O ClikMob é desenvolvido por um grupo de profissionais que acreditam que tecnologia e  empatia podem caminhar lado a lado.  Nosso compromisso é com o respeito, a valorização do trabalho e a construção de um serviço  de mobilidade mais humano e acessível.
                    </div>
                </div>
                <div style={styles.logo1}>
                    <div style={styles.imageContainer}>
                        <img 
                            src={IMAGE_PATHS.mainImage} 
                            alt="Equipe ClikMob" 
                            style={styles.logoImage} 
                            onError={(e) => {
                                const target = e.target as HTMLImageElement;
                                target.style.display = 'none';
                            }}
                        />
                    </div>
                </div>
            </div>
            <div style={styles.subTitle}>
                Estamos unindo inovação, responsabilidade e propósito para transformar o jeito de se mover  — e queremos que você venha com a gente.
            </div>
            <div style={styles.container}>
                <div style={styles.subContainer2}>
                    <div style={styles.logo}>
                        <div style={styles.imageContainer}>
                            <img 
                                src={IMAGE_PATHS.teamPhoto1} 
                                alt="Foto da equipe 1" 
                                style={styles.logoImage}
                                onError={(e) => {
                                    const target = e.target as HTMLImageElement;
                                    target.style.display = 'none';
                                }}
                            />
                        </div>
                    </div>
                    <div style={styles.logo}>
                        <div style={styles.imageContainer}>
                            <img 
                                src={IMAGE_PATHS.teamPhoto3} 
                                alt="Foto da equipe 3" 
                                style={styles.logoImage}
                                onError={(e) => {
                                    const target = e.target as HTMLImageElement;
                                    target.style.display = 'none';
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div style={styles.subContainer2}>
                    <div style={styles.logo}>
                        <div style={styles.imageContainer}>
                            <img 
                                src={IMAGE_PATHS.teamPhoto2} 
                                alt="Foto da equipe 2" 
                                style={styles.logoImage}
                                onError={(e) => {
                                    const target = e.target as HTMLImageElement;
                                    target.style.display = 'none';
                                }}
                            />
                        </div>
                    </div>
                    <div style={styles.logo}>
                        <div style={styles.imageContainer}>
                            <img 
                                src={IMAGE_PATHS.teamPhoto4} 
                                alt="Foto da equipe 4" 
                                style={styles.logoImage}
                                onError={(e) => {
                                    const target = e.target as HTMLImageElement;
                                    target.style.display = 'none';
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Footer
                color={Colors.white}
                backgroundColor={Colors.primary}
                image="/LOGO%20TM%203.svg"
            />
        </Screen>
    );
}
